"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlogClient = void 0;
const slugify_1 = __importDefault(require("slugify"));
class BlogClient {
    constructor(key) {
        if (!key)
            throw Error('SEObot API key must be provided. You can use the DEMO key a8c58738-7b98-4597-b20a-0bb1c2fe5772 for testing');
        this._key = key;
    }
    _decompressIndex(short) {
        return {
            id: short.id,
            slug: short.s,
            headline: short.h,
            metaDescription: short.d,
            image: short.i,
            readingTime: short.rt,
            createdAt: short.cr,
            category: short.c
                ? {
                    title: short.c.t,
                    slug: (0, slugify_1.default)(short.c.t, { lower: true, strict: true }),
                }
                : null,
            tags: (short.tg || []).map(i => ({
                title: i.t,
                slug: (0, slugify_1.default)(i.t, { lower: true, strict: true }),
            })),
        };
    }
    _fetchIndex() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`https://cdn.seobotai.com/${this._key}/system/base.json`, { cache: 'no-store' });
            const index = (yield response.json());
            return index.map(i => this._decompressIndex(i)).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
        });
    }
    _fetchArticle(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const postData = yield fetch(`https://cdn.seobotai.com/${this._key}/blog/${id}.json`, { cache: 'no-store' });
            const post = (yield postData.json());
            return post;
        });
    }
    getArticles(page, limit = 10) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const base = yield this._fetchIndex();
                const start = page * limit;
                const end = start + limit;
                return {
                    articles: base.slice(start, end),
                    total: base.length,
                };
            }
            catch (_a) {
                return { total: 0, articles: [] };
            }
        });
    }
    getCategoryArticles(slug, page, limit = 10) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const base = yield this._fetchIndex();
                const categoryIds = base.filter(i => { var _a; return ((_a = i.category) === null || _a === void 0 ? void 0 : _a.slug) == slug; }).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
                const start = page * limit;
                const end = start + limit;
                return {
                    articles: categoryIds.slice(start, end),
                    total: categoryIds.length,
                };
            }
            catch (_a) {
                return { total: 0, articles: [] };
            }
        });
    }
    getTagArticles(slug, page, limit = 10) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const base = yield this._fetchIndex();
                const tags = base.filter(i => i.tags.some(item => (item === null || item === void 0 ? void 0 : item.slug) === slug)).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
                const start = page * limit;
                const end = start + limit;
                return {
                    articles: tags.slice(start, end),
                    total: tags.length,
                };
            }
            catch (_a) {
                return { total: 0, articles: [] };
            }
        });
    }
    getArticle(slug) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const base = yield this._fetchIndex();
                const record = base.find(item => item.slug === slug);
                if (!record)
                    return null;
                const post = yield this._fetchArticle(record.id);
                return post;
            }
            catch (_a) {
                return null;
            }
        });
    }
}
exports.BlogClient = BlogClient;
